import {Competitor} from "./competitor";
import {TOAST_STATE, ToastState} from '@model';

export class AssignChipNumbersResponse {
    constructor(public assigned?: Competitor[], public notAssigned?: Competitor[], public duplicateStartNumbers?: Competitor[], public duplicateChipNumbers?: Competitor[]) {
    }

    static buildToastMessage( result: AssignChipNumbersResponse, translate: (key: string) => string ): { state: ToastState; message: string } {
        let toastState = TOAST_STATE.danger;
        let resultMessage = "";
        if (result.assigned?.length) {
            toastState = TOAST_STATE.success;
            resultMessage = translate( "race.management.competitors.assign.chip.numbers.success" );
            if (result.notAssigned?.length) {
                const assignedList = result.assigned .map((c) => `<br>${c.startNumber} - ${c.chipNumber}`) .join(", ");
                const notAssignedList = result.notAssigned .map((c) => `<br>${c.startNumber} - ${c.chipNumber}`) .join(", ");

                resultMessage += `${assignedList}`;
                resultMessage += `<br><br>${translate( "race.management.competitors.assign.chip.numbers.none.assigned" )}`;
                resultMessage += `${notAssignedList}`;
            }
        }
        else {
            resultMessage = translate( "race.management.competitors.assign.chip.numbers.none.assigned" );
        }
        if (result.duplicateStartNumbers?.length) {
            const uniqueStartNumbers = [ ...new Set(result.duplicateStartNumbers.map((c) => c.startNumber)), ];
            const multipleList = uniqueStartNumbers
                .map((sn) => `<br>${sn}`) .join(", "); resultMessage += `<br><br>${translate( "race.management.competitors.assign.chip.numbers.error" )}:`;
            resultMessage += `${multipleList}`;
        }
        if (result.duplicateChipNumbers?.length) {
            const duplicateChipNumbers = result.duplicateChipNumbers
                .map( (c) => `<br>${c.startNumber} - ${ c.teamMembers?.length ?
                    c.teamMembers.map((t) => t.chipNumber).join(",") : c.chipNumber }` )
                .join(", ");
            resultMessage += `<br><br>${translate( "race.management.competitors.assign.chip.numbers.duplicate" )}:`;
            resultMessage += `${duplicateChipNumbers}`;
        } return { state: toastState, message: resultMessage };
    }
}